import {
  AdCampaignData,
  ChannelCampaign,
} from '@promoboxx/graphql-gateway-types'
import { useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import useCurrentRetailerAccount from '@src/lib/useCurrentRetailerAccount'
import { usePaidAds } from '@src/lib/usePaidAds'

export default function useCombinedPremiumAdData(campaignId: string) {
  const { currentRetailerAccount } = useCurrentRetailerAccount()
  const { getChannelCampaign } = usePaidAds()
  const [channelCampaign, setChannelCampaign] =
    useState<ChannelCampaign | null>(null)

  const campaign: AdCampaignData | null = useSelector(
    (state: {
      ad: { paidAdsById: { [key: string]: AdCampaignData | null } }
    }) => state?.ad?.paidAdsById?.[campaignId],
  ) as AdCampaignData | null

  // const channelCampaignId = campaign?.campaign_channels?.[0]?.id
  const campaignChannelId = campaign?.campaign_channels?.[0]?.id || null

  //TODO: Utilize the new GQL call to get a campaign by id for a retailer...
  // useEffect(() => {
  //   if (campaignId) {
  //     getPaidAd(campaignId, retailerId).then((response) => {
  //       console.log(response)
  //       setCampaign(response)
  //     })
  //   }
  // }, [campaignId, getPaidAd])

  useEffect(() => {
    if (campaignChannelId && currentRetailerAccount) {
      const retailerId: string | null =
        currentRetailerAccount?.retailers?.find((r) => {
          return r.brand_id === campaign?.brand_id
        })?.id || null
      if (retailerId) {
        getChannelCampaign(campaignChannelId, retailerId).then((response) => {
          setChannelCampaign(response)
        })
      }
    }
  }, [
    campaign?.brand_id,
    campaignChannelId,
    currentRetailerAccount,
    getChannelCampaign,
  ])

  const adCreativeTemplate = useMemo(() => {
    return channelCampaign?.adcreative_templates?.[0] || null
  }, [channelCampaign])

  const adSetTemplate = useMemo(() => {
    return channelCampaign?.ad_set_templates?.[0] || null
  }, [channelCampaign])

  return {
    campaign,
    campaignChannelId,
    channelCampaign,
    /** Easy access to `channelCampaign.adcreative_templates[0]` */
    adCreativeTemplate,
    /** Easy access to `channelCampaign.ad_set_templates[0]` */
    adSetTemplate,
  }
}
